export const legendMarkWidth = 160;
export const legendMarkHeight = 32;
export const gap100 = 8;
export const gap200 = 16;
export const symbolSize = 12;
export const horizontalLegendRows = 2;
export const MAX_LEGEND_ENTRIES = 10000;